export default {"src":"/_next/static/media/disc-wheels.a1af1c25.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};